export default class PaymentTerms {
  constructor(el) {
    this._el = el;
    this._reference = this._el.querySelector('[data-payment-terms-reference] shopify-payment-terms');

    if (!this._reference) return;

    this._targets = this._el.querySelectorAll('[data-payment-terms-target]');
    this._inputs = [];

    // Reach uses separate markup for desktop and mobile so we need
    // to copy the terms to both places.
    this._targets.forEach(target => {
      const input = document.createElement('input');
      input.name = 'id';
      input.type = 'hidden';

      target.appendChild(input);
      target.appendChild(this._reference.cloneNode(true));

      target.style.display = null;

      this._inputs.push(input);
    });
  }

  update(variantId) {
    if (!this._reference) return;
    this._inputs.forEach(input => {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
